import { Phone, MapPin, Facebook } from "lucide-react";
import { CONTACT } from "@/lib/menuData";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[color:var(--brand-red)] text-white border-t-4 border-[color:var(--brand-ink)] relative noise">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="inline-block bg-[color:var(--brand-ink)] text-white font-display text-xl px-2.5 py-0.5 -rotate-3">EL</span>
              <span className="font-display text-2xl uppercase">Loco Taco</span>
            </div>
            <p className="mt-3 text-white/90 max-w-xs">
              Authentic Mexican street food in Hartford, MI. Loud flavors, friendly faces.
            </p>
          </div>

          <div>
            <p className="font-bold uppercase text-xs tracking-[0.2em] text-[color:var(--brand-yellow)]">Call Us</p>
            <ul className="mt-3 space-y-2">
              {CONTACT.phones.map((p, i) => (
                <li key={p.href}>
                  <a
                    href={p.href}
                    data-testid={`footer-phone-${i + 1}`}
                    className="inline-flex items-center gap-2 font-display text-2xl uppercase hover:text-[color:var(--brand-yellow)] transition-colors"
                  >
                    <Phone size={18} strokeWidth={2.75} /> {p.display}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-bold uppercase text-xs tracking-[0.2em] text-[color:var(--brand-yellow)]">Visit</p>
            <p className="mt-3 inline-flex items-start gap-2 font-semibold">
              <MapPin size={18} strokeWidth={2.75} className="mt-0.5" />
              {CONTACT.address}
            </p>
            <a
              href={CONTACT.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="mt-5 inline-flex items-center gap-2 bg-white text-[color:var(--brand-red)] font-bold uppercase px-4 py-2 border-2 border-[color:var(--brand-ink)] shadow-brutal-sm btn-brutal"
            >
              <Facebook size={16} strokeWidth={2.75} /> Follow on Facebook
            </a>
          </div>
        </div>

        <div className="mt-16 border-t-2 border-white/40 pt-10 text-center">
          <h3
            data-testid="footer-thanks"
            className="font-display uppercase leading-[0.85] text-[14vw] sm:text-[12vw] lg:text-[10rem]"
            style={{ WebkitTextStroke: "0", color: "#fff" }}
          >
            Thank You For Your Support
          </h3>
          <p className="mt-6 text-white/80 text-sm">
            © {new Date().getFullYear()} El Loco Taco — Hartford, MI. Hecho con amor.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
